/** 基础样式 勿删 */
import '../static/css/sm.css'
/** sm.js 勿删 */
import '../static/js/sm.js'

import './css/reset.css'
import './css/common.css'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

/** 基础API 勿删 */
import '../lib/commons/tuhu'
/** 获取第三方渠道 */
// import '../lib/commons/channel'
import layout from './pages/layout.vue'
import store from './store/store'
import util from './commons/util'
import citypicker from '../lib/components/citypicker.vue'

// vantUI Toast可以直接this.$toast()调用'
// import VConsole from 'vconsole/dist/vconsole.min.js' // import vconsole
import {
  Empty,
  NumberKeyboard,
  Search,
  Tag,
  DatetimePicker,
  DropdownMenu,
  DropdownItem,
  ActionSheet,
  Collapse,
  CollapseItem,
  Pagination,
  Toast,
  Icon,
  Button,
  Switch,
  Cell,
  Uploader,
  CellGroup,
  Field,
  Popup,
  Picker,
  Tab,
  Tabs,
  NoticeBar,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Dialog,
  TreeSelect,
  Stepper,
  Image
} from 'vant'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

Vue.use(Button)
  .use(Switch)
  .use(Cell)
  .use(CellGroup)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Tab)
  .use(Tabs)
  .use(NoticeBar)
  .use(Toast)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(RadioGroup)
  .use(Radio)
  .use(Uploader)
  .use(Icon)
  .use(Dialog)
  .use(Pagination)
  .use(Collapse)
  .use(CollapseItem)
  .use(ActionSheet)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(DatetimePicker)
  .use(Tag)
  .use(Empty)
  .use(NumberKeyboard)
  .use(Search)
  .use(TreeSelect)
  .use(Stepper)
  .use(Image)
Vue.component('tuhu-citypicker', citypicker)

// loading加载
import kun from './commons/kun'
Vue.prototype.$kun = kun
/** 加载layout */
new Vue({
  el: $('#root')[0],
  mounted() {},
  render: h => {
    return h(layout)
  }
})
// let vConsole = new VConsole()
Vue.prototype.util = util
/** 自己控制初始化路由 */
const url = tuhu.getFullPath(location.href)
const params = tuhu.getParams() || {}
const token = params['x-auth-token']
if (token) tuhu.localStorage.setItem('shop-token', token)
tuhu.redirectTo({
  url: url,
  query: tuhu.getParams()
})
tuhu.store = store
/** 页面加载完成删除index.html中的loading动画 */
$('#tuhuloadmore').hide()



// WEBPACK FOOTER //
// ./src/main.js